import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/plan/license.plan.seatSources.query.gql"
import type {
  LicenseSeatSourcesQuery,
  LicenseSeatSourcesQueryVariables,
} from "@/v2-backoffice-client/license/plan/__types__/license.plan.seatSources.query"

type Options = QueryHookOptions<
  LicenseSeatSourcesQuery,
  LicenseSeatSourcesQueryVariables
>

export function useLicenseSeatSourcesQuery(options?: Options) {
  return useQuery<LicenseSeatSourcesQuery, LicenseSeatSourcesQueryVariables>(
    query,
    options,
  )
}
